import { Component } from '@angular/core';
import { AlertService, NavigationService, LoaderEnabled, LoaderService } from 'sce-core';
import { SearchService } from '../../../search/search.service';
import { SearchParams } from '../../../search/models/search-params.model';
import { DataTableConfig } from '../../../search/models/data-table-config';
import { SearchStatus } from '../../../search/models/search-status.model';
import { SharedServiceRegistry } from '../../../shared-service-registry';
import { SearchCriteria, Clause, Condition } from '../../../search/models/search-filter-model';
import { ButtonItem } from '../../../button/button.model';
import { CoreServiceRegistry } from '../../../../core/core-service-registry';
import { DataTableEditorService } from '../../../search/results/data-table-editor.service';
import { Observable } from 'rxjs/Observable';
import { ALLOCATION_STATUS, CASE_ID_CONFIG_KEY, menuIdRouteMappings, SEARCH_KEYS, TABLE_NAME, YES } from '../../../../constants';
import { Subject } from 'rxjs/Subject';
import { ValidatorService } from '../../../services/validator.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { PickManagementPopupDataEditorService } from './pick-management-popup-data-editor.service';
import { DISPLAY_MODE, FINALIZE_STATUS, NEW_ROW_EVENT, NEW_SEARCH_EVENT, PAGE_OVERFLOW_EVENT, REFRESH_SEARCH_EVENT } from '../../../search/search-constants';
import { SearchEvent } from '../../../search/models/search-event';
import { DATA_TABLE_LINE_PROP, PICK_MNGT_URL, PICK_SERIALNO_ERROR, PICK_SERIALNO_TAB, TAB_LIST, TAB_LIST_WAVE_CONTROL } from '../../../../features/outbound/pick-management/services/pick-management-tables';
import { MessageType, PickManagementConstants } from '../../../models/message-type.config';
import { HttpStatusCode } from '../../../models/http-status-code.constants';
import { API_URL } from 'app/shared/models/api-urls';

@Component({
  selector: 'lfwms-pick-management-popup',
  templateUrl: './pick-management-popup.component.html',
  styleUrls: ['./pick-management-popup.component.css'],
})
export class PickManagementPopupComponent {

  public tabbedSearchServices: Array<SearchService> = [];
  public skuDetailSearchService: any;
  public selectedTabIndex: any;
  public lookupAlertService: AlertService;
  private waveIdValue: string;
  public tabHeaders: Array<string> = [];
  public notFullyAllocButtons: any; // button array for Not Full Allocated Order Detail Tab
  public fullyAllocButtons: any; // button array for Full Allocated Order Detail Tab
  public preAllocPickButtons: any;// button array for Pre Allocated Pick Order Detail Tab
  public pickSerialNoButtons = [];
  public showPrimaryTabSection: boolean;
  public showDetailsSection: boolean; // section which is shown on click of button actions
  public dataEditor: any;
  public showSkuDetailSection: boolean;
  public showViewBalancePopupSection: boolean;
  public storerKey: string;
  public facility: string;
  public inputConfig: any; // input values for the view-balances-popup
  protected loaderService: LoaderService; 
  private isCaseIDEditable: boolean = true;
  //public http$ = this.coreServiceRegistry.http$;
  public resourceService = this.coreServiceRegistry.resourceService;
  protected navService: NavigationService;
  public errorMsg: string = '';
  public alertService: AlertService;
  public eventSubject = new Subject<any>();
  public loadKey: string;
  public tableMode = 'V';
  public metaData: any;
  public screenTypeLine : string = 'line';
  public screenTypeAll  : string = 'all';
  public uniqueStorerFacilityEditableCaseID: any = [];

  constructor(
    private sharedServiceRegistry: SharedServiceRegistry,
    private coreServiceRegistry: CoreServiceRegistry,
    protected validatorService: ValidatorService,
    protected http$: HttpClient
  ) {
    this.lookupAlertService = new AlertService();
    this.loaderService = new LoaderService();
    this.navService = coreServiceRegistry.navigationService;
    for (let key in TAB_LIST_WAVE_CONTROL) {
      if (!isNaN(Number(key))) {
          continue; 
      }
      this.tabHeaders.push(key);
    }
    this.notFullyAllocButtons = [
      //[LFWM-3529] export button added to the pick management pop up page
      new ButtonItem('Export', this.resourceService.get('lbl_export'), 'not_fully_alloc_export', 'tray-arrow-up',
        [
          new ButtonItem('Export as Excel', this.resourceService.get('btn_exportExcel'), 'not_fully_alloc_export', 'tray-arrow-up', []),
          new ButtonItem('Export as CSV', this.resourceService.get('btn_exportCSV'), 'not_fully_alloc_export', 'tray-arrow-up', [])
        ]),
      new ButtonItem('Views', this.resourceService.get('btn_views'), 'pick_views', 'eye',
        [
          new ButtonItem('Lot', this.resourceService.get('btn_lot'), 'pick_views_lot', '', []),
          new ButtonItem('Lot by Loc by Movable Unit', this.resourceService.get('btn_lot_by_loc_by_movable_unit'), 'pick_views_lot_by_loc', '', []),
          new ButtonItem('SKU Detail', this.resourceService.get('lbl_sku_detl'), 'pick_views_sku_detail', '', []),
        ]),
      // tslint:disable-next-line:max-line-length
      new ButtonItem('Splits Not fully Allocated New Order', this.resourceService.get('btn_split_not_full_aloc_new_ordr'),
        'wv_ctrl_pick_split', 'icon-split-notfully-allocate.svg', []),
    ];
    // LFWM-2040 Wave Control Pick Management add unallocate button
    this.fullyAllocButtons = [
      //[LFWM-3529] export button added to the pick management pop up page
      new ButtonItem('Export', this.resourceService.get('lbl_export'), 'not_fully_alloc_export', 'tray-arrow-up',
        [
          new ButtonItem('Export as Excel', this.resourceService.get('btn_exportExcel'), 'not_fully_alloc_export', 'tray-arrow-up', []),
          new ButtonItem('Export as CSV', this.resourceService.get('btn_exportCSV'), 'not_fully_alloc_export', 'tray-arrow-up', [])
        ]),
      new ButtonItem('Edit', this.resourceService.get('btn_edit'), 'wv_ctrl_pick_edit', 'pencil', []),
      new ButtonItem('Save', this.resourceService.get('btn_save'), '', 'floppy-disk', []),
      new ButtonItem('Add Row', this.resourceService.get('lbl_AddNewRow'), 'wv_ctrl_pick_add', 'plus-circle', []),
      new ButtonItem('Copy Value To All Rows', this.resourceService.get('btn_copy_values_to_all'), 'wv_ctrl_pick_copy', 'copy', []),
      new ButtonItem('UnAllocate_Main', this.resourceService.get('btn_unallocate'), 'wv_ctrl_pick_unalloc', 'times', [
        new ButtonItem('UnAllocate Line Item(s)', this.resourceService.get('btn_unallocate_line'),
          'wv_ctrl_pick_line_unalloc', 'times', []),
        new ButtonItem('UnAllocate All Line Items', this.resourceService.get('btn_unallocate_all_lines'),
          'wv_ctrl_pick_all_unalloc', 'times', []),
        new ButtonItem('UnAllocate By Wave', this.resourceService.get('btn_unallocate_by_wave'),
          'wv_ctrl_pick_wav_unalloc', 'times', []),
        new ButtonItem('UnAllocate By Load', this.resourceService.get('btn_unallocate_by_load'),
          'wv_ctrl_pick_load_unalloc', 'times', []),
      ])];
    this.preAllocPickButtons = [
      //[LFWM-3529] export button added to the pick management pop up page
      new ButtonItem('Export', this.resourceService.get('lbl_export'), 'not_fully_alloc_export', 'tray-arrow-up',
        [
          new ButtonItem('Export as Excel', this.resourceService.get('btn_exportExcel'), 'not_fully_alloc_export', 'tray-arrow-up', []),
          new ButtonItem('Export as CSV', this.resourceService.get('btn_exportCSV'), 'not_fully_alloc_export', 'tray-arrow-up', [])
        ]),
      new ButtonItem('Delete_Main', this.resourceService.get('btn_delete'), 'wv_ctrl_pick_del', 'trash', [
        new ButtonItem('Delete Line Item(s)', this.resourceService.get('btn_delete_line'), 'wv_ctrl_pick_del', 'trash', [])
      ])];
    this.pickSerialNoButtons = [
        new ButtonItem('UNALLOCATEPICK_MAIN', this.resourceService.get('btn_unallocatepick'), 'pick_unalloc_unpick', 'times', [
        new ButtonItem('UNPICK_BY_LINE_ITEMS', this.resourceService.get('btn_unpick_line'),
            'unpick_line_item', 'times', []),
        new ButtonItem('UNPICK_AND_UNALLOCATE_BY_LINE_ITEMS', this.resourceService.get('btn_unpick_unallocate_line'),
            'unpick_unalloc_line_item', 'times', []),
        new ButtonItem('UNPICK_ALL_LINE_ITEMS', this.resourceService.get('btn_unpick_all_lines'),
            'unpick_all_lines', 'times', []),
        new ButtonItem('UNPICK_AND_UNALLOCATE_ALL_LINE_ITEMS', this.resourceService.get('btn_unpick_unallocate_all_lines'),
            'unpick_unallocate_all_lines', 'times', [])]
      )];
  }

  public initializeComponents(waveIdValue: string, loadKey: any, facility: string) {
    this.showPrimaryTabSection = true;
    this.waveIdValue = waveIdValue;
    this.loadKey = loadKey;
    this.facility = facility;
    //LFWM-3233--AU - Cannot Sort by SKU in Pick Management from Wave Control
    const tableEditor: DataTableEditorService = new PickManagementPopupDataEditorService(this.coreServiceRegistry,
      this.sharedServiceRegistry);
    this.dataEditor = tableEditor;
    this.initializeSearchServices();
    this.refreshButtons();
  }

  private initializeSearchServices() {
    this.tabbedSearchServices.push(this.createSearchService('notfullyalloctd', 'waveKey', this.waveIdValue));
    this.tabbedSearchServices.push(this.createSearchService('allocpickdettd', 'waveKey', this.waveIdValue));
    this.tabbedSearchServices.push(this.createSearchService('preallocpickdettd', 'waveDetWaveKey', this.waveIdValue));
    this.tabbedSearchServices.push(this.createSearchService('allocpksernotd', 'waveKey', this.waveIdValue));
    // to initialize the table for first tab
    if (!this.selectedTabIndex) {
      this.selectedTabIndex = 0;
      this.tabbedSearchServices[this.selectedTabIndex].performSearch();
    }
  }

  public createSearchService(tableId: string, primaryKey: string, primaryValue: string) {
    const searchParams = new SearchParams();
    searchParams.tableId = tableId;
    searchParams.isFullFetch = true;
    searchParams.columnCount = 10;
    searchParams.defaultSearchColumn = '';
    searchParams.idProperty = primaryKey;
    //LFWM-3233--AU - Cannot Sort by SKU in Pick Management from Wave Control
    searchParams.tableEditor = this.dataEditor;
    const tableConfig: DataTableConfig = new DataTableConfig();
    tableConfig.supportFiltering = true;
    tableConfig.editable = true;
    searchParams.dataTableConfig = tableConfig;
    searchParams.alertService = this.lookupAlertService;
    switch (tableId) {
      case 'notfullyalloctd' :
        searchParams.actionButtons = this.sharedServiceRegistry.buttonFactoryService.loadButtonsByPrivilege(this.notFullyAllocButtons);
        break;
      case 'allocpickdettd' : 
        searchParams.actionButtons = this.sharedServiceRegistry.buttonFactoryService.loadButtonsByPrivilege(this.fullyAllocButtons);
        searchParams.dataTableConfig.isColumnEditable = (params: any) => {
          const rowData = params.data;
          if (this.tableMode === DISPLAY_MODE.VIEW_PAGE || this.tableMode === DISPLAY_MODE.VIEW) {
            return false;
          }
          const caseIDStatusCheck = params.colDef.colId === SEARCH_KEYS.CASEID_POPUP && rowData['status'] && rowData['status'].cVal >= ALLOCATION_STATUS.PICKED && !this.isCaseIDEditable;
          return !caseIDStatusCheck;
        };
        break;
      case 'preallocpickdettd' : 
        searchParams.actionButtons = this.sharedServiceRegistry.buttonFactoryService.loadButtonsByPrivilege(this.preAllocPickButtons);
        break;
      case 'allocpksernotd' : 
        searchParams.actionButtons = this.sharedServiceRegistry.buttonFactoryService.loadButtonsByPrivilege(this.pickSerialNoButtons);
        break;
    }
    const searchStatus = new SearchStatus();
    const searchService = this.sharedServiceRegistry.createSearchService(searchParams, searchStatus);
    const defaultSearchCriteria = this.createSearchCriteria(primaryKey, primaryValue);
    searchService.setSearchCriteria(defaultSearchCriteria);

    return searchService;
  }

  protected createSearchCriteria(primaryKey: string, primaryValue: string) {
    const defaultSearchCriteria = new SearchCriteria();
    defaultSearchCriteria.conditions = [];
    defaultSearchCriteria.loadDefaultCriteria = false;
    const defaultCondition = this.createSearchCondition(1);
    defaultCondition.isReadOnly = false;
    defaultCondition.isMandatory = true;

    const defaultClause = new Clause();
    defaultClause.column = primaryKey;
    defaultClause.value = primaryValue;
    defaultClause.operation = '=';
    defaultClause.logicalOperation = 'AND';

    defaultCondition.clauses = [defaultClause];
    defaultSearchCriteria.conditions.push(defaultCondition);

    return defaultSearchCriteria;
  }

  protected createSearchCondition(id: any) {
    const searchCondition = new Condition();
    searchCondition.id = id;
    searchCondition.displayMode = 'VIEW';
    return searchCondition;
  }

  //[LFWM-3529][export functionality added to wave control -> pick management popup]
  protected checkIfPageDataAvailable() {
    if (!this.tabbedSearchServices[this.selectedTabIndex] || !this.tabbedSearchServices[this.selectedTabIndex].pagedData ||
      !this.tabbedSearchServices[this.selectedTabIndex].pagedData.pageDefinition ||
      this.tabbedSearchServices[this.selectedTabIndex].pagedData.pageDefinition.recordCount === 0) {
      this.tabbedSearchServices[this.selectedTabIndex].searchParams.actionButtons.forEach((buttonItem) => {
        if (buttonItem.action === 'Export' || buttonItem.action === 'Delete_Main') {
          buttonItem.isEnabled = false;
          buttonItem.isVisible = false;
        }
      });
    }
  }

  public onTabChange(tabId: any) {
    this.selectedTabIndex = TAB_LIST_WAVE_CONTROL[tabId];
    // re-initializing the table when the tab changes
    this.tabbedSearchServices[this.selectedTabIndex].performSearch();
    this.setMetaData();
    this.tabbedSearchServices[this.selectedTabIndex]
      .receiveEvent()
      .subscribe((event: SearchEvent) => {
        this.checkIfPageDataAvailable();
        if (event.type === NEW_SEARCH_EVENT) {
          this.refreshButtons();
          this.checkIfCaseIDEditablePerFacilityStorer();
        } else if (event.type === NEW_ROW_EVENT) {
          this.refreshButtons();
          this.initializeValuesForNewLineItemRow(
            this.tabbedSearchServices[this.selectedTabIndex],
            event.selectedRow
          );

        } else if (event.type === PAGE_OVERFLOW_EVENT) {
          // This event comes when a page overflow has occured. Save the corrent page and navigate to the next
          // page on success
          this.tabbedSearchServices[this.selectedTabIndex].setNewPageEventInProgress(true);
          //this.buttonService.performButtonActions('Save');
        }
      });
  }

  private setMetaData() {
    if (!this.tabbedSearchServices[this.selectedTabIndex].getMetadata()) {
      this.tabbedSearchServices[this.selectedTabIndex].fetchMetadata().subscribe((metadata: any) => {
        this.metaData = metadata;
        // sorting the metadata based on indexes
        this.metaData.columnList.sort(function (a: any, b: any) {
          return a.index - b.index; // compare indexes
        });
        this.tabbedSearchServices[this.selectedTabIndex].setMetadata(metadata);
      });
    }
  }

  public getLabel(key: any) {
    return this.resourceService.get(key);
  }

  public handleButtonAction(action: any) {
    switch (action) {
      case 'Lot': {
        this.showBalances('L');
        break;
      }
      case 'Lot by Loc by Movable Unit': {
        this.showBalances('M');
        break;
      }
      case 'SKU Detail': {
        this.skuDetail();
        break;
      }
      case 'Splits Not fully Allocated New Order': {
        this.splitNotFullyAllocNewOrder();
        break;
      }
      // LFWM-2040 Wave Control Pick Management add unallocate button
      case 'UnAllocate Line Item(s)': {
        this.unallocateLineItem();
        break;
      }
      case 'UnAllocate All Line Items': {
        this.unallocateAllLineItem();
        break;
      }
      case 'UnAllocate By Wave': {
        this.unallocateByWavekey();
        break;
      }
      case 'UnAllocate By Load': {
        this.unallocateByLoadkey();
        break;
      }
      case 'Edit': {
        this.tableMode = 'E';
        this.refreshButtons();
        break;
      }
      case 'Save': {
        this.savePage();
        break;
      }
      case 'Copy Value To All Rows': {
        this.copyValueToAllRows();
        break;
      }
      case 'Export as Excel': {
        this.exportAsExcel();
        break;
      }
      case 'Export as CSV': {
        this.exportAsCSV();
        break;
      }
      case 'Delete Line Item(s)': {
        this.deleteLineItem();
        break;
      }
      case 'UNPICK_BY_LINE_ITEMS': {
        const dialogMsg = 'msg_unpick_dtl';
        this.unpickLineItem(PickManagementConstants.unpickAction,dialogMsg);
        break;
      }
      case 'UNPICK_AND_UNALLOCATE_BY_LINE_ITEMS': {
        const dialogMsg = 'msg_unpick_unalc_dtl';
        this.unpickLineItem(PickManagementConstants.unpickUnallocate,dialogMsg);
        break;
      }
      case 'UNPICK_ALL_LINE_ITEMS': {
        const dialogMsg = 'msg_unpick_all_dtl';
        this.unpickUnallocateAllLineItem(PickManagementConstants.unpickAction,dialogMsg);
        break;
      }
      case 'UNPICK_AND_UNALLOCATE_ALL_LINE_ITEMS': {
        const dialogMsg = 'msg_unpick_unalc_all_dtl';
        this.unpickUnallocateAllLineItem(PickManagementConstants.unpickUnallocate,dialogMsg);
        break;
      }
    }
  }
  public unpickUnallocateAllLineItem(action,dialogMsg) {
    const noOfLineItems = this.tabbedSearchServices[this.selectedTabIndex].getPagedData().pageDefinition.recordCount;
    const selectedRow = this.tabbedSearchServices[this.selectedTabIndex].getPagedData().pageRows;
    if (noOfLineItems > 0) {
      this.sharedServiceRegistry.confirmDialogService.confirmDialog(this.resourceService.get(dialogMsg))
        .subscribe((isConfirmed: any) => {
          if (isConfirmed) {
            const lineItemProp = DATA_TABLE_LINE_PROP.lbl_pick_serialno;
            const newLineItemNumbers: Array<string> = [];
            let hasExistingLineItems = false;
            selectedRow.forEach((row: any) => {
              if (row.cells['isNewItem'] && row.cells['isNewItem'].cVal === true) {
                newLineItemNumbers.push(row.cells[lineItemProp].cVal);
              } else {
                hasExistingLineItems = true;
              }
            });
            if (newLineItemNumbers.length > 0) {
              this.tabbedSearchServices[this.selectedTabIndex].deleteRowsFromModel(lineItemProp, newLineItemNumbers);
            }
            if (hasExistingLineItems) {
              const allRows = this.tabbedSearchServices[this.selectedTabIndex].getPagedData().pageRows;
              if (allRows && allRows.length > 0) {
                const storerkey = allRows[0].cells.storerKey.cVal;
                const unallocatedKeys = []; // keys unallocated sucessfully
                const errMsgArray = [];
                const request = [{
                  'storerKey': storerkey,
                  'waveKey': this.waveIdValue,
                  'action': action,
                  'pickSerialNos': [],
                  'tableId': PICK_SERIALNO_TAB.pickserialno,
                  'screenType': this.screenTypeLine
                }];
                this.unPickUnallocateAllItems(request).subscribe((response: any) => {
                  for (let i = 0; i < response.length; i++) {
                    if (response[i].statusCode === HttpStatusCode.ok) {
                      unallocatedKeys.push(response[i].pickDetailKey);
                    } else {
                      const errMsg = `${response[i].pickDetailKey ? response[i].pickDetailKey + ' ' : ''}${response[i].statusMessage}`;
                      errMsgArray.push(errMsg);
                    }
                  }
                  // if any of the key is unallocated then show the success message and refresh the page
                  if (unallocatedKeys.length > 0) {
                    const successMsg = action === PickManagementConstants.unpickAction ? this.resourceService.get('msg_unpick_succ') : this.resourceService.get('msg_unpick_unalc_succ');
                    this.lookupAlertService.clearAll().success(`${successMsg}  ${unallocatedKeys}`);
                    this.tabbedSearchServices[this.selectedTabIndex].performSearch();
                  }
                  if (errMsgArray.length > 0) {
                    this.lookupAlertService.clearAll().error(errMsgArray);
                  }
                }, (error) => {
                  this.lookupAlertService.clearAll().error(this.resourceService.get(error));
                });
              }
            }
          }
        });
    }
  }
  @LoaderEnabled()
  public unPickUnallocateAllItems(request) {
    const response$ = this.http$.post(PICK_MNGT_URL.unpickallocate, JSON.stringify(request))
      .map((response: any) => {
        return response;
      }).catch((error: any) => {
        if (error.error.length !== 0) {
          if (error.error.statusCode !== HttpStatusCode.ok) {
            return Observable.throw(error.error.statusMessage);
          }
        }
      });
    return response$;
  }
  public createLineItemsForUnPick(selectedRows) {
    const lineItemObjArray = [];
    selectedRows.forEach(lineitem => {
      lineItemObjArray.push(
        lineitem.cells.PickSerialNoKey.cVal
      );
    });
    return lineItemObjArray;
  }
  public unpickItems(storerkey, orderKey, selectedRows, screenType: any,action) {
    // LFWM-3191- passing tableId in the request.
    const request = [{
      'storerKey': storerkey,
      'orderKey': '',
      'action': action,
      'pickSerialNos': this.createLineItemsForUnPick(selectedRows),
      'tableId': PICK_SERIALNO_TAB.pickserialno,
      'screenType': screenType
    }];
    const response$ = this.http$.post(PICK_MNGT_URL.unpickallocate, JSON.stringify(request))
      .map((response: any) => {
        return response;
      }).catch((error: any) => {
        if (error.error.length !== 0) {
          if (error.error.statusCode !== HttpStatusCode.ok) {
            return Observable.throw(error.error.statusMessage);
          }
        }
      });
    return response$;
  }

  public unpickLineItem(action,dialogMsg) {
    const openTabSearchService = this.tabbedSearchServices[this.selectedTabIndex];
    const selectedRows = openTabSearchService.getSelectedRows();
    if (selectedRows.length === 0) {
      this.lookupAlertService.clearAll().error(this.resourceService.get('msg_sel_detail'));
      return;
    }
    if (selectedRows.length > 0) {
      this.sharedServiceRegistry.confirmDialogService.confirmDialog(this.resourceService.get(dialogMsg))
        .subscribe((isConfirmed: any) => {
          if (isConfirmed) {
            const orderKey = selectedRows[0].cells.orderKey.cVal;
            const storerkey = selectedRows[0].cells.storerKey.cVal;
            const lineItemProp = DATA_TABLE_LINE_PROP.lbl_pick_serialno;
            const selectedRow = this.tabbedSearchServices[this.selectedTabIndex].getSelectedRows();
            const existingLineItemNumbers: Array<any> = [];
            const newLineItemNumbers: Array<string> = [];
            selectedRow.forEach((row: any) => {
              if (row.cells['isNewItem'] && row.cells['isNewItem'].cVal === true) {
                newLineItemNumbers.push(row.cells[lineItemProp].cVal);
              } else {
                existingLineItemNumbers.push({
                  'value': row.cells[lineItemProp].cVal,
                  'index': row.rIdx
                });
              }
            });
            if (newLineItemNumbers.length > 0) {
              this.tabbedSearchServices[this.selectedTabIndex].deleteRowsFromModel(lineItemProp, newLineItemNumbers);
            }
            if (existingLineItemNumbers.length > 0) {
              const unallocatedKeys = []; // keys unallocated sucessfully
              const errMsgArray = [];
              this.unpickItems(storerkey, orderKey, selectedRows, this.screenTypeLine, action).subscribe((response: any) => {
                for (let i = 0; i < response.length; i++) {
                  if (response[i].statusCode === HttpStatusCode.ok) {
                    unallocatedKeys.push(response[i].pickSerialNokey);
                  } else {
                    const errMsg = `${response[i].pickSerialNokey} - ${response[i].statusMessage}`;
                    this.handleTabChange(response[i].statusMessage);
                    errMsgArray.push(errMsg);
                  }
                }
                // if any of the key is unallocated then show the success message and refresh the page
                if (unallocatedKeys.length > 0) {
                  const successMsg = action === PickManagementConstants.unpickAction ? this.resourceService.get('msg_unpick_succ') : this.resourceService.get('msg_unpick_unalc_succ');
                  this.lookupAlertService.clearAll().success( `${successMsg}  ${unallocatedKeys}`);
                  this.tabbedSearchServices[this.selectedTabIndex].performSearch();
                }
                if (errMsgArray.length > 0) {
                  this.lookupAlertService.clearAll().error(errMsgArray);
                }
              }, (error) => {
                this.lookupAlertService.clearAll().error(this.resourceService.get(error));
              });
            }
          }
        });
    } else {
      this.lookupAlertService.clearAll();
      this.lookupAlertService.error(this.resourceService.get(this.errorMsg));
    }
  }
  /**
   * Lot / Lot by Loc by Movable Unit Button
   */
  public showBalances(balanceType: string) {
    let viewBalanceTitle: string;
    const openTabSearchService = this.tabbedSearchServices[this.selectedTabIndex];
    const selectedRows = openTabSearchService.getSelectedRows();
    if (openTabSearchService.getPagedData().pageRows.length === 0) {
      this.lookupAlertService.clearAll()
        .error(this.resourceService.get('msg_no_detail'));
      return;
    } else if (openTabSearchService.getSelectedRows().length === 0) {
      this.lookupAlertService.clearAll()
        .error(this.resourceService.get('msg_sel_detail'));
      return;
    } else if (openTabSearchService.getSelectedRows().length > 1) {
      this.lookupAlertService.clearAll()
        .error(this.resourceService.get('msg_multiple_entries'));
      return;
    } else {
      this.lookupAlertService.clearAll();
      this.showPrimaryTabSection = false;
      this.showDetailsSection = true;
      this.showViewBalancePopupSection = true;
      if (balanceType === 'L') {
        viewBalanceTitle = this.resourceService.get('btn_lot');
      } else if (balanceType === 'M') {
        viewBalanceTitle = this.resourceService.get('btn_lot_by_loc_by_movable_unit');
      }
      this.coreServiceRegistry.modalService.modalReference.overlayConfig.overlayHeader =
        this.coreServiceRegistry.modalService.modalReference.overlayConfig.overlayHeader + ' / ' +
        this.resourceService.get('lbl_not_fully_alloc') + ' / ' + viewBalanceTitle;
      // input values for the view-balances-popup
      this.inputConfig = {
        'storerKey': this.storerKey,
        'sku': selectedRows[0].cells['sku'].cVal,
        'balanceType': balanceType,
        'tableId': this.tabbedSearchServices[this.selectedTabIndex].searchParams.tableId
      };
    }
  }
  public handleTabChange(errorMsg) {
    if (errorMsg.includes(PICK_SERIALNO_ERROR['Allocated_For_SerialNo'])) {
      this.sharedServiceRegistry.confirmDialogService.okDialog(errorMsg).subscribe(
        (result)=>{
          this.onTabChange(TAB_LIST_WAVE_CONTROL.lbl_pick_serialno);
        }
      );
    }
  }
  public backToDetailsPage() {
    this.showDetailsSection = false;
    this.showViewBalancePopupSection = false;
    this.showSkuDetailSection = false;
    this.showPrimaryTabSection = true;
    this.tabbedSearchServices[this.selectedTabIndex].performSearch();
    const popupTitle = this.resourceService.get('mn_pick_mgmnt');
    // we need to reset popup header name which is accessed from coreServiceRegistry.modalService
    this.coreServiceRegistry.modalService.modalReference.overlayConfig.overlayHeader = popupTitle;
  }

  public splitNotFullyAllocNewOrder() {
    const request = [
      {
        'waveKey': this.waveIdValue
      }
    ];
    this.loaderService.showLoader();
    this.splitNotFullyAllocNewOrderBackendCall(request).subscribe((resp: any) => {
      this.loaderService.hideLoader();
      const isSuccess = resp.waveSplitOrderList[0].status[0].statusCode === HttpStatusCode.ok && resp.waveSplitOrderList[0].status[0].statusMessage === MessageType.msgSuccess;
      const isFailure = resp.waveSplitOrderList[0].status[0].statusCode === HttpStatusCode.internalServerError && resp.waveSplitOrderList[0].status[0].statusMessage === MessageType.msgFailure;
      if (isSuccess) {
        this.lookupAlertService.clearAll().success(resp.waveSplitOrderList[0].status[0].message);
        // [LFWM-2007] - Not Fully Allocated table should be refreshed on success of Split Not Fully Allocated NewOrder
        this.tabbedSearchServices[this.selectedTabIndex].performSearch();
      } else if (isFailure) {
        this.lookupAlertService.clearAll().error(resp.waveSplitOrderList[0].status[0].message);
      }
    },
    (error) => {
      this.loaderService.hideLoader();
      this.lookupAlertService.clearAll().error(this.resourceService.get(error));
    });
  }

  public splitNotFullyAllocNewOrderBackendCall(request: any) {
    const response$ = this.http$.post('api/wave/order/split ', JSON.stringify(request))
      .map((response: any) => {
        return response;
      })
      .catch((error: any) => {
        if (error.error.length !== 0) {
          if (error.error.statusCode !== 200) {
            return Observable.throw(error.error.statusMessage);
          }
        }
      });
    return response$;
  }
  // LFWM-2040 Wave Control Pick Management add unallocate button
  /** START - LFWM-2040 Wave Control Pick Management add unallocate button */
  public unallocateLineItem() {
    const openTabSearchService = this.tabbedSearchServices[this.selectedTabIndex];
    const selectedRows = openTabSearchService.getSelectedRows();
    const dialogMsg = 'msg_unalc_dtl';    
    const errorMsg = 'msg_sel_detail';
    const noOfLineItems = openTabSearchService.getPagedData().pageDefinition.recordCount;
    if (noOfLineItems === 0) {
      const errMsg = 'msg_no_detail';
      this.lookupAlertService.clearAll().error(this.resourceService.get(errMsg));
      return;
    }
    if (selectedRows.length > 0) {
      this.sharedServiceRegistry.confirmDialogService.confirmDialog(this.resourceService.get(dialogMsg))
        .subscribe((isConfirmed: any) => {
          if (isConfirmed) {
            let storerkey: any;
            let orderKey: any;
            let selectedRowLsit: any = {};
            const request: any[] = [];
            /*LFWM-2040,have handled request as a list of objects*/
            selectedRows.forEach(selectedRow => {
              storerkey = selectedRow.cells.storerkey.cVal;
              orderKey = selectedRow.cells.orderkey.cVal;
              // LFWM-3191- passing tableId and screenType in the request.
              selectedRowLsit = {
                'storerKey': storerkey,
                'orderKey': orderKey,
                'unallocateAll': false,
                'unallocateFrom': 'UAPICKLINE',
                'pickDetails': this.createLineItemsForUnallocate(selectedRow),
                'tableId': this.tabbedSearchServices[this.selectedTabIndex].searchParams.tableId,
                'screenType': this.screenTypeLine
              };
              request.push(selectedRowLsit);
            });
            this.unallocateItems(request).subscribe((response: any) => {
              //sonar issue fixed - duplicate line of code removed and created common function
              this.checkResponse(response, openTabSearchService);
            }, (error) => {
              this.lookupAlertService.clearAll().error(this.resourceService.get(error));
            });
          }
        });
    } else {
      this.lookupAlertService.clearAll();
      this.lookupAlertService.error(this.resourceService.get(errorMsg));
    }
  }

  public unallocateAllLineItem() {
    const openTabSearchService = this.tabbedSearchServices[this.selectedTabIndex];
    const noOfLineItems = openTabSearchService.getPagedData().pageDefinition.recordCount;
    const dialogMsg = 'msg_unalc_all_dtl';
    const errorMsg = 'msg_no_detail';
    if (noOfLineItems > 0) {
      this.sharedServiceRegistry.confirmDialogService.confirmDialog(this.resourceService.get(dialogMsg))
        .subscribe((isConfirmed: any) => {
          if (isConfirmed) {
            const allRows = openTabSearchService.getPagedData().pageRows;
            // LFWM-3191- passing tableId in the request.
            if (allRows && allRows.length > 0) {
              const request = [{
                'storerKey': allRows[0].cells.storerkey.cVal,
                'unallocateAll': true,
                'unallocateFrom': 'UAWAVE',
                'pickDetails': [{
                  'waveKey': this.waveIdValue,
                }],
                'tableId': this.tabbedSearchServices[this.selectedTabIndex].searchParams.tableId,
                'screenType': this.screenTypeAll
              }];

              this.unallocateAllItems(request).subscribe((response: any) => {
                //sonar issue fixed - duplicate line of code removed and created common function               
                this.checkResponse(response, openTabSearchService);
              }, (error) => {
                this.lookupAlertService.clearAll().error(this.resourceService.get(error));
              });
            }
          }
        });
    } else {
      this.lookupAlertService.clearAll();
      this.lookupAlertService.error(this.resourceService.get(errorMsg));
    }
  }

  //sonar issue fixed - duplicate line of code removed and created common function
  private checkResponse(response, openTabSearchService) {
    const unallocatedKeys = []; // keys unallocated sucessfully
    const errMsgArray = [];
    const successMsg = 'msg_unalc_all_succ';    
    for (let resp of response) {
      if (resp.statusCode === 200) {
        unallocatedKeys.push(resp.pickDetailKey);
      } else {
        const errMsg = resp.statusMessage + ' ' + resp.pickDetailKey;
        errMsgArray.push(errMsg);
      }
    }
    if (unallocatedKeys.length > 0) {
      this.lookupAlertService.clearAll().success(this.resourceService.get(successMsg) + ' ' + unallocatedKeys);
      openTabSearchService.performSearch();
      this.notifyEvent({ 'type': 'unallocate' });
    }
    if (errMsgArray.length > 0) {
      this.lookupAlertService.clearAll().error(errMsgArray);
    }
  }

  public unallocateItems(request) {
    const response$ = this.http$.post(`api/outbound/pick/unallocate/`, JSON.stringify(request))
      .map((response: any) => {
        return response;
      }).catch((error: any) => {
        if (error.error.length !== 0) {
          if (error.error.statusCode !== 200) {
            return Observable.throw(error.error.statusMessage);
          }
        }
      });
    return response$;
  }

  // method used to create the line items in required format for unallocate action
  public createLineItemsForUnallocate(selectedRows: any) {
    const lineItemObjArray = [];
    lineItemObjArray.push(
      {
        'pickDetailKey': selectedRows.cells.pickDetailKey.cVal,
        'orderLineNo': selectedRows.cells.orderlinenumber.cVal,
        'loadKey': '',
        'waveKey': this.waveIdValue,
        'sku': selectedRows.cells.sku.cVal,

      }
    );
    return lineItemObjArray;
  }

  // method used to unallocate all the line items
  @LoaderEnabled()
  public unallocateAllItems(request: any) {
    /** Request must be changed. Needs API analysis.
     * records have different orderIds. Hence current request can’t be used.
     */
    /* const request = [{
       'storerKey': storerkey,
       'orderKey': orderKey,
       'unallocateAll': true,
       'pickDetails': []
     }];*/
    const response$ = this.http$.post(`api/outbound/pick/unallocate/`, JSON.stringify(request))
      .map((response: any) => {
        return response;
      }).catch((error: any) => {
        if (error.error.length !== 0) {
          if (error.error.statusCode !== 200) {
            return Observable.throw(error.error.statusMessage);
          }
        }
      });
    return response$;
  }
  /** END - LFWM-2040 Wave Control Pick Management add unallocate button */

  /*LFWM-1966 */
  public skuDetail() {
    const openTabSearchService = this.tabbedSearchServices[this.selectedTabIndex];
    const selectedRows = openTabSearchService.getSelectedRows();
    const noOfLineItems = openTabSearchService.getPagedData().pageDefinition.recordCount;
    if (noOfLineItems === 0) {
      this.errorMsg = 'msg_no_detail';
      this.lookupAlertService.clearAll().error(this.resourceService.get(this.errorMsg));
      return ;
    }
    if (selectedRows.length === 0) {
      this.errorMsg = 'msg_sel_detail';
      this.lookupAlertService.clearAll().error(this.resourceService.get(this.errorMsg));
      return ;
    }
    if (selectedRows.length > 1) {
      this.errorMsg = 'msg_sel_lin_itm';
      this.lookupAlertService.clearAll().error(this.resourceService.get(this.errorMsg));
      return ;
    }
    if (selectedRows.length !== 0 && selectedRows.length === 1) {
      const selectedSku = selectedRows[0].cells['sku'].cVal;
      if (selectedSku == null) {
        this.errorMsg = 'msg_slct_comm';
        this.lookupAlertService.clearAll().error(this.resourceService.get(this.errorMsg));
        return ;
      }
      // code to navigate to sku page with the selected sku id
      const skuUrl: string = menuIdRouteMappings['commodity'];
      const waveCntrlUrl: string = menuIdRouteMappings['wave_ctrl'] + '/wave-control/' + this.waveIdValue;
      this.navService.preventNavigation = false;
      this.sharedServiceRegistry.sceModalService.modalReference.hide();
      this.navService.removeLastBreadCrumbItem().addBreadCrumbItem('Wave Control Detail',
        waveCntrlUrl + '?retainState=1');
      this.navService.navigateByUrl(skuUrl + '/details/' + selectedSku);
    }
  }

  public notifyEvent(value: any) {
    this.eventSubject.next(value);
  }

  public receiveEvent(): Observable<any> {
    return this.eventSubject.asObservable();
  }

  // [LFWM-2902] - unallocate by wave functionality
  public unallocateByWavekey() {
    const openTabSearchService = this.tabbedSearchServices[this.selectedTabIndex];
    const noOfLineItems = openTabSearchService.getPagedData().pageDefinition.recordCount;
    const screenType = 'wav';
    if (noOfLineItems > 0) {
      this.sharedServiceRegistry.confirmDialogService.confirmDialog(this.resourceService.get('msg_unalc_by_wave'))
        .subscribe((isConfirmed: any) => {
          if (isConfirmed) {
            const allRows = openTabSearchService.getPagedData().pageRows;
            if (allRows && allRows.length > 0) {
              const request = [{
                'storerKey': allRows[0].cells.storerkey.cVal,
                'unallocateAll': false,
                'unallocateFrom': 'UAWAVE',
                'pickDetails': [{
                  'waveKey': this.waveIdValue,
                }],
                'tableId': this.tabbedSearchServices[this.selectedTabIndex].searchParams.tableId,
                'screenType': screenType
              }];
              this.unallocateAllItems(request).subscribe((response: any) => {
                if (response[0].statusCode === 200) {
                  this.lookupAlertService.clearAll().success(this.resourceService.get('msg_unalc_by_wave_succ'));
                  this.notifyEvent({ 'type': 'unallocate' });
                  openTabSearchService.performSearch();
                } else {
                  this.lookupAlertService.clearAll().error(response[0].statusMessage);
                }
              }, (error) => {
                this.lookupAlertService.clearAll().error(this.resourceService.get(error));
              });
            }
          }
        });
    } else {
      this.lookupAlertService.clearAll();
      this.lookupAlertService.error(this.resourceService.get('msg_no_detail'));
    }
  }

  // [LFWM-2902] - unallocate by load functionality
  public unallocateByLoadkey() {
    if (!this.loadKey) {
      this.lookupAlertService.clearAll().error(this.resourceService.get('pls_sel_load_tab'));
      return;
    }
    const openTabSearchService = this.tabbedSearchServices[this.selectedTabIndex];
    const noOfLineItems = openTabSearchService.getPagedData().pageDefinition.recordCount;
    const screenType = 'load';
    if (noOfLineItems > 0) {
      this.sharedServiceRegistry.confirmDialogService.confirmDialog(this.resourceService.get('msg_unalc_by_load'))
        .subscribe((isConfirmed: any) => {
          if (isConfirmed) {
            const allRows = openTabSearchService.getPagedData().pageRows;
            if (allRows && allRows.length > 0) {
              const request = [{
                'storerKey': allRows[0].cells.storerkey.cVal,
                'unallocateAll': false,
                'unallocateFrom': 'UALOAD',
                'pickDetails': [{
                  'loadKey': this.loadKey
                }],
                'tableId': this.tabbedSearchServices[this.selectedTabIndex].searchParams.tableId,
                'screenType': screenType
              }];
              this.unallocateAllItems(request).subscribe((response: any) => {
                if (response[0].statusCode === 200) {
                  this.lookupAlertService.clearAll().success(this.resourceService.get('msg_unalc_by_load_succ'));
                  openTabSearchService.performSearch();
                  this.notifyEvent({ 'type': 'unallocate' });
                } else {
                  this.lookupAlertService.clearAll().error(response[0].statusMessage);
                }
              }, (error) => {
                this.lookupAlertService.clearAll().error(this.resourceService.get(error));
              });
            }
          }
        });
    } else {
      this.lookupAlertService.clearAll();
      this.lookupAlertService.error(this.resourceService.get('msg_no_detail'));
    }
  }

  // LFWM- 3240 Function to refresh the table mode
  private refreshButtons() {
    this.fullyAllocButtons.forEach((button: ButtonItem) => {
      const editModeButtons = ['Save', 'Add Row', 'Copy Value To All Rows'];
      if (editModeButtons.includes(button.action)) {
        button.isEnabled = this.tableMode === 'E';
        button.isVisible = this.tableMode === 'E';
      } else if (button.action === 'Edit') {
        button.isEnabled = this.tableMode === 'V';
        button.isVisible = this.tableMode === 'V';
      } else if (button.action === 'UnAllocate_Main') {
        button.isEnabled = true;
        button.isVisible = true;
      }
      //[LFWM-3529][export functionality added to wave control -> pick management popup]
      else if (button.action === 'Export') {
        if (!this.tabbedSearchServices[this.selectedTabIndex] || !this.tabbedSearchServices[this.selectedTabIndex].pagedData ||
          !this.tabbedSearchServices[this.selectedTabIndex].pagedData.pageDefinition ||
          this.tabbedSearchServices[this.selectedTabIndex].pagedData.pageDefinition.recordCount !== 0) {
          button.isEnabled = this.tableMode === 'V';
          button.isVisible = this.tableMode === 'V';
        }
      }
    });
  }

  // LFWM- 3240 Method used to save the Allocate pick details
  public savePage(): Observable<any> {
    let lineItems: Array<any>;
    const newItemsToSave = [];
    let detailItems = [];
    if (this.tableMode === 'E') {
      // set the line item properties
      lineItems = this.tabbedSearchServices[this.selectedTabIndex].getEditedRows();
      // get the newitems
      // adding the warning so as to avoid saving when no modifications are done to the ASN and trying to save.
      if (lineItems.length === 0) {
        this.errorMsg = 'msg_no_mod';
        this.lookupAlertService.clearAll().warn(this.resourceService.get(this.errorMsg));
        this.tabbedSearchServices[this.selectedTabIndex].clearMarkerFlags();
        this.navService.preventNavigation = false;
        this.tableMode = 'V';
        this.refreshButtons();
        return;
      } else {
        detailItems = this.getLineItemsForSaveRequest(lineItems);
      }
    }
    const errorIfAny = this.validateLineItems(detailItems);
    if (errorIfAny) {
      this.errorMsg = errorIfAny;
      this.lookupAlertService.clearAll().error(this.resourceService.get(this.errorMsg));
      return;
    }
    // added to validate the user entred data
    if (this.validateUserEnteredData()) {
      this.savePick(detailItems).subscribe((response) => {
        if (response.statusCode === 200) {
          const successMsg = 'msg_save_succ';
          this.lookupAlertService.clearAll().success(this.resourceService.get(successMsg));
          this.tabbedSearchServices[this.selectedTabIndex].performSearch();
          this.tabbedSearchServices[this.selectedTabIndex].clearMarkerFlags();
          this.navService.preventNavigation = false;
          this.tableMode = 'V';
          this.refreshButtons();
        } else {
          this.lookupAlertService.clearAll().error(response.statusMessage);
        }
      }, (error) => {
        this.lookupAlertService.clearAll().error(this.resourceService.get(error));
      });
    }
  }

  //  LFWM- 3240 - method to validate the line items before saving the pick detail
  public validateLineItems(lineItems) {
    if (lineItems.length !== 0) {
      let orderLineFlag = false;
      let lotFlag = false;
      let locFlag = false;
      let idFlag = false;
      lineItems.forEach((detail: any, index: any) => {
        detail.cells.forEach(property => {
          if (property.cName === 'orderlinenumber' && !property.cVal) {
            orderLineFlag = true;
          } else if (property.cName === 'lot' && !property.cVal) {
            lotFlag = true;
          } else if (property.cName === 'loc' && !property.cVal) {
            locFlag = true;
          } else if (property.cName === 'id' && (property.cVal == null || property.cVal === undefined)) {
            idFlag = true;
          }
        });
      });
      if (orderLineFlag) {
        return this.resourceService.get('err_msg_val_orderLineNo');
      } else if (lotFlag) {
        return this.resourceService.get('err_msg_val_lot');
      } else if (locFlag) {
        return this.resourceService.get('err_msg_val_loc');
      } else if (idFlag) {
        return this.resourceService.get('err_msg_val_id');
      }
    }
    return null;
  }

  public getLineItemsForSaveRequest(lineItems) {
    const detailItemsForSave = [];
    lineItems.forEach(row => {
      const cellsKeyArray = Object.keys(row.cells);
      const keyValueList = [];
      cellsKeyArray.forEach(key => {

        if (key === 'uom') {
          if (row.cells[key].cVal === 'Each') {
            keyValueList.push({ 'cName': key, 'cVal': '6' });
          } else if (row.cells[key].cVal === 'Pallet') {
            keyValueList.push({ 'cName': key, 'cVal': '1' });
          } else if (row.cells[key].cVal === 'Case') {
            keyValueList.push({ 'cName': key, 'cVal': '2' });
          } else if (row.cells[key].cVal === 'Inner Pack') {
            keyValueList.push({ 'cName': key, 'cVal': '3' });
          } else {
            keyValueList.push({ 'cName': key, 'cVal': row.cells[key].cVal });
          }
        }
        else {
          keyValueList.push({ 'cName': key, 'cVal': row.cells[key].cVal });
        }
      });
      detailItemsForSave.push({
        'rIdx': detailItemsForSave.length,
        'cells': keyValueList
      });
    });
    return detailItemsForSave;
  }

  //  LFWM- 3240 - added to validate user entred data
  public validateUserEnteredData() {
    const validateLineItemsErr = this.validatorService.validateMultipleRows(this.tabbedSearchServices[this.selectedTabIndex].
      getMetadata(), this.tabbedSearchServices[this.selectedTabIndex].getPagedData());
    if (validateLineItemsErr) {
      return false;
    } else {
      return true;
    }
  }

  public savePick(lineItems: any) {
    const request = {
      'documentType': 'allocpickdettd',
      'primaryProperties': [],
      'detailItems': lineItems
    };
    const response$ = this.http$.post(`api/common/detail`, JSON.stringify(request))
      .map((response: any) => {
        return response;
      }).catch((error: any) => {
        if (error.error.length !== 0) {
          if (error.error.statusCode !== 200) {
            return Observable.throw(error.error.statusMessage);
          }
        }
      });
    return response$;
  }

  //LFMW-3240 - Function to intialize the values for fields when a new row is added
  public initializeValuesForNewLineItemRow(searchService, newRow) {
    const allLineItems = searchService.getPagedData().pageRows;
    if (this.metaData) {
      this.metaData.columnList.forEach(property => {
        if (property.displayType === 'EA') {
          /* This method is called to populate any restricted values
          The below method will be invoked when we try to add the new row*/
          this.dataEditor.populateRestrictedValues(allLineItems, property.propertyName);
        }
      });
    }
    const lineItemProp = DATA_TABLE_LINE_PROP.lbl_alloc_pick;
    let propertyArray = [];
    if (allLineItems && allLineItems.length > 1) {
      let lastRow = allLineItems[allLineItems.length - 1];
      if (lastRow.cells[lineItemProp].cVal === '') {
        // if this is the new row, move to the previous one
        lastRow = allLineItems[allLineItems.length - 2];
      }
      propertyArray = Object.keys(lastRow.cells);
      propertyArray.forEach((prop: any) => {
        if (prop !== 'isNewItem') {
          newRow.cells[prop].cName = prop;
          if (prop === 'status' || prop === 'qty') {
            newRow.cells[prop].cVal = '0';
          } else if (prop === 'uom') {
            newRow.cells[prop].cVal = 'Each';
          } else if (prop === 'storerkey' && this.storerKey) {
            newRow.cells[prop].cVal = this.storerKey;
          } else if (prop === 'pickDetailKey') {
            searchService
              .createUniqueId('PICKDETAIL')
              .subscribe((response: any) => {
                if (response && response.documentNumber) {
                  newRow.cells[prop].cVal = response.documentNumber;
                } else {
                  this.alertService.error(
                    this.resourceService.get('err_creation_failed')
                  );
                }
              });
            // LFWM-3557-Removing the autopopulation of lot value.
          } else if (prop === 'lot') {
            newRow.cells[prop].cVal = '';
           // LFWM-3557-adding default value as '00001' for orderlineno  
          } else if (prop === 'orderlinenumber') {
            newRow.cells[prop].cVal = '00001';
          } else {
            newRow.cells[prop].cVal = lastRow.cells[prop].cVal;
          }
        }
      });
    } else if (allLineItems.length === 1) {
      const lastRow = allLineItems[0];
      propertyArray = Object.keys(lastRow.cells);
      propertyArray.forEach((prop: any) => {
        if (prop !== 'isNewItem') {
          newRow.cells[prop].cName = prop;
          if (prop === 'waveKey') {
            newRow.cells[prop].cVal = this.waveIdValue;
          } else if (prop === 'status' || prop === 'qty') {
            newRow.cells[prop].cVal = '0';
          } else if (prop === 'uom') {
            newRow.cells[prop].cVal = 'Each';
          } else if (prop === 'storerkey' && this.storerKey) {
            newRow.cells[prop].cVal = this.storerKey;
          } else if (prop === 'pickDetailKey') {
            searchService
              .createUniqueId('PICKDETAIL')
              .subscribe((response: any) => {
                if (response && response.documentNumber) {
                  newRow.cells[prop].cVal = response.documentNumber;
                } else {
                  this.alertService.error(
                    this.resourceService.get('err_creation_failed')
                  );
                }
              });
          // LFWM-3557- giving default values
          } else if (prop === 'uomqty') {
            newRow.cells[prop].cVal = '1';
          } else if (prop === 'qtyMoved') {
            newRow.cells[prop].cVal = '';
          } else if (prop === 'pickMethod') {
            newRow.cells[prop].cVal = '';
          } else if (prop === 'orderlinenumber') {
              newRow.cells[prop].cVal = '00001';
          } else {
            newRow.cells[prop].cVal = '';
          }
        }
      });
      // LFWM-3557-If no lineItem is there , then CASEID is created using number api
      this.generateUniqueKey(newRow, 'CASEID');
    }
    this.generateUniqueKey(newRow, 'PICKHEADER');
  }

  //LFWM-3240 Function to generte unique valeu to pickDetaikey, caseid and pickheaderkey
  private generateUniqueKey(newRow: any, moduleId: string) {
    this.tabbedSearchServices[this.selectedTabIndex]
      .createUniqueId(moduleId)
      .subscribe((response: any) => {
        if (response && response.documentNumber) {
          if (moduleId === 'PICKHEADER') {
            newRow.cells['pickheaderkey'].cVal = response.documentNumber;
          } else if (moduleId === 'CASEID') {
            newRow.cells['caseid'].cVal = response.documentNumber;
          }
        } else {
          this.alertService.error(
            this.resourceService.get('err_creation_failed')
          );
        }
      });
  }

  public handleMainButtonPanelActions(action) {
    const haveUnsavedData =
      this.tabbedSearchServices[this.selectedTabIndex].getEditedCellsPerRow().length > 0;
    if (haveUnsavedData) {
      this.handleButtonActionForEdit(action);
    } else {
      this.handleButtonAction(action);
    }
  }

  public handleButtonActionForEdit(action: any) {
    let needYesNoConfirmation = false;
    switch (action) {
      case 'Save': {
        needYesNoConfirmation = false;
        break;
      }
    }
    if (!(needYesNoConfirmation)) {
      this.handleButtonAction(action);
    }
  }

  protected exportAsExcel() {
    this.exportData(this.tabbedSearchServices[this.selectedTabIndex], 'excel');
  }

  protected exportAsCSV() {
    this.exportData(this.tabbedSearchServices[this.selectedTabIndex], 'csv');
  }

  //[LFWM-3529][export functionality added to wave control -> pick management popup]
  protected exportData(searchService: SearchService, format: string) {
    if (!searchService || !format) {
      this.lookupAlertService.error('');
      return;
    }
    // Alert user and continue export in background   
    this.lookupAlertService.warn(this.resourceService.get('msg_export_bg_info'));
    searchService.exportData(format).subscribe((resp) => {
      const blob = new Blob([this.s2ab(atob(resp.content))]);
      const file = new File([blob], resp.fileName, { type: 'text/csv' });
      this.sharedServiceRegistry.fileUtilityService.saveFileLocally(file);
    });
  }

  private s2ab(s) {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i !== s.length; ++i) {
      // tslint:disable-next-line:no-bitwise
      view[i] = s.charCodeAt(i) & 0xFF;
    }
    return buf;
  }


  /* Start - LFWM-3663 Wave Control Pick Management add delete button for pre allocated picks*/
  public deleteLineItem() {
    const openTabSearchService = this.tabbedSearchServices[this.selectedTabIndex];
    const selectedRows = openTabSearchService.getSelectedRows();
    const dialogMsg = 'msg_del_detail';    
    const errorMsg = 'msg_sel_detail';
    const noOfLineItems = openTabSearchService.getPagedData().pageDefinition.recordCount;
    if (noOfLineItems === 0) {
      const errMsg = 'msg_no_detail';
      this.lookupAlertService.clearAll().error(this.resourceService.get(errMsg));
      return;
    }
    if (selectedRows.length > 0) {
      this.sharedServiceRegistry.confirmDialogService.confirmDialog(this.resourceService.get(dialogMsg))
        .subscribe((isConfirmed: any) => {
          if (isConfirmed) {
            const lineItemProp = DATA_TABLE_LINE_PROP.lbl_pre_alloc_pick;
            const tableId = this.tabbedSearchServices[this.selectedTabIndex].searchParams.tableId;
            const selectedRow = openTabSearchService.getSelectedRows();
            const existingLineItemNumbers: Array<any> = [];
            const newLineItemNumbers: Array<string> = [];
            selectedRow.forEach((row: any) => {
              if (row.cells['isNewItem'] && row.cells['isNewItem'].cVal === true) {
                newLineItemNumbers.push(row.cells[lineItemProp].cVal);
              } else {
                existingLineItemNumbers.push({
                  'value': row.cells[lineItemProp].cVal,
                  'index': row.rIdx
                });
              }
            });
            if (newLineItemNumbers.length > 0) {
              openTabSearchService.deleteRowsFromModel(lineItemProp, newLineItemNumbers);
            }
            if (existingLineItemNumbers.length > 0) {
              this.deleteSelectedLineItem(lineItemProp, tableId, existingLineItemNumbers)
                .subscribe((resp: any) => {
                  if (resp['statusCode'] && resp['statusMessage']) {
                    if (resp['statusCode'] === 200 && resp['statusMessage'] === 'SUCCESS') {
                      // code to reload the detail grid
                      this.lookupAlertService.clearAll();
                      this.lookupAlertService.success(this.resourceService.get('msg_del_itm_succ'));
                      openTabSearchService.performSearch();
                    }
                  } else {
                    if (resp.error) {
                      this.lookupAlertService.clearAll();
                      this.lookupAlertService.error(this.resourceService.get(resp.error));
                    }
                  }
                }, (error) => {
                  this.lookupAlertService.clearAll().error(this.resourceService.get(error));
                });
            }
          }
        });
    } else {
      this.lookupAlertService.clearAll();
      this.lookupAlertService.error(this.resourceService.get(errorMsg));
    }
  }

  @LoaderEnabled()
  public deleteSelectedLineItem(lineItemProp: any, tableId: any, selectedLineItemNumbers: any): Observable<Response> {
    const lineItemListReq = [];
    selectedLineItemNumbers.forEach((lineItemNo: any) => {
      lineItemListReq.push({
        'rIdx': lineItemNo.index, 'cells': [{ cName: lineItemProp, cVal: lineItemNo.value },
        ]
      });
    });
    const request = {
      'detailType': tableId,
      'detailItems': lineItemListReq
    };
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: request,
    };
    const response$ = this.http$.delete(`api/common/delete`, options)
      .map((response: any) => {
        if (response['errors']) {
          if (response['errors'][0].validationCode !== 200) {
            return Observable.throw(response['errors'][0].validationMessage);
          }
        } else {
          return response;
        }
      }).catch((error: any) => {
        // return Observable.throw(error.message);
        if (error.error.length !== 0) {
          if (error.error.statusCode !== 200) {
            return Observable.throw(error.error.statusMessage);
          }
        }
      });
    return response$;
  }

  public copyValueToAllRows(): void {
    const searchService = this.tabbedSearchServices[this.selectedTabIndex];
    this.errorMsg = 'msg_no_detail';
    let selectedColumnToCopy = '';
    if (searchService.getAllRows().length === 0) {
      this.lookupAlertService.clearAll().error(this.resourceService.get(this.errorMsg));
      return;
    }
    if (searchService.getFocusedRow().cName) {
      selectedColumnToCopy = searchService.getFocusedRow().cName;
    }
    const msgNoFocusRow: string = 'msg_clik_cell_to_copy_value';
    const msgCantCopyField: string = 'msg_cant_copy_field';

    if (!selectedColumnToCopy || (selectedColumnToCopy === 'isSelected')) {
      this.lookupAlertService.clearAll().error(this.resourceService.get(msgNoFocusRow));
      return;
    }
    const displayTypeSelectedField =
      searchService.getMetadataForProperty(selectedColumnToCopy).displayType;
    // Non editable field values should not be allowed to copy as they are set from other editable fields
    if (displayTypeSelectedField === DISPLAY_MODE.VIEW_PAGE) {
      this.lookupAlertService.clearAll().error(this.resourceService.get(msgCantCopyField));
      return;
    }
    let valueToCopy = '';
    if (searchService.getFocusedRow().row) {
      valueToCopy = searchService.getFocusedRow().row.cells[selectedColumnToCopy].cVal;
    }

    const dialogMsg = this.resourceService.get('msg_copy_colmn') + this.resourceService.get(selectedColumnToCopy)
      + this.resourceService.get('msg_to_all_rows') + this.resourceService.get(selectedColumnToCopy)
      + this.resourceService.get('msg_overwrt');
    this.sharedServiceRegistry.confirmDialogService.confirmDialog(dialogMsg)
      .subscribe((isConfirmed: any) => {
        if (isConfirmed) {
          // code to copy the selected row value to all rows
          searchService.getPagedData().pageRows.forEach((lineItemRows: any) => {
            const lineItemCells = lineItemRows.cells;
            // preserve behavior: skip rows that are finalized/closed if present
            if (lineItemCells.status && lineItemCells.status.cValOrig === FINALIZE_STATUS) {
              return;
            }
            lineItemCells[selectedColumnToCopy].cVal = valueToCopy;
            lineItemCells[selectedColumnToCopy]['isEdited'] = true;
            lineItemRows.isEdited = true;
          });
          searchService.publishEvent(new SearchEvent(REFRESH_SEARCH_EVENT));
        }
      });
  }
  /** END - LFWM-3663 Wave Control Pick Management add delte button for pre allocated picks */
  public async checkIfCaseIDEditablePerFacilityStorer() {
    const pagedData = this.tabbedSearchServices[this.selectedTabIndex].getPagedData();
    if (!pagedData || !pagedData.pageRows) {
      return;
    }
    const data = pagedData.pageRows;
    const filterStorerFacility = data.map((item) => {
      return {storer: this.storerKey, facility: this.facility}
    });
    this.uniqueStorerFacilityEditableCaseID = Object.values(filterStorerFacility.reduce((acc, obj) => ({ ...acc, [obj.storer]: obj }), {}));
    await Promise.all(
      this.uniqueStorerFacilityEditableCaseID.map(async (el: {storer: string, facility: string, editableCaseID?: boolean}) => {
        el.editableCaseID = await this.getCaseIDDetails(el.storer, el.facility);
      })
    );
  }

  public async getCaseIDDetails(storerKey: string, facilityKey: string): Promise<boolean> {
    const resp = await this.getIfCaseIDIsEnabled(storerKey, facilityKey);
    const isValidResponse = resp && resp['statusCode'] === HttpStatusCode.ok && resp['statusMessage'] === MessageType.msgSuccess;
    if (isValidResponse) {
      if (resp['hasRights'] === YES) {
         this.isCaseIDEditable = false;
         return false;
      } else {
         this.isCaseIDEditable = true;
         return true;
      }
    } else {
      if (this.alertService && this.resourceService) {
         this.alertService.error(this.resourceService.translateServerResponse(this.resourceService.get('msg_execute_getrights_failure')));
      }
      return true;
    }
  }

  public async getIfCaseIDIsEnabled(storerKey: string, facilityKey: string) {
    return await this.getStorerConfigurationForFacility(facilityKey, storerKey, CASE_ID_CONFIG_KEY, TABLE_NAME.PICK_TD).toPromise();
  }
  
  private getStorerConfigurationForFacility(facilityVal: string, storerKeyVal: string, configKey: string, tableId: string): Observable<Response> {
    const request = {
      'facility': facilityVal,
      'storerKey': storerKeyVal,
      'configKey': configKey,
      'tableId': tableId
    };
    const response$ = this.http$.post(API_URL.RIGHTS, JSON.stringify(request))
      .catch((error: any) => {
        const isErrorResponseValid = error && error.error && error.error.length !== 0 && error.error.statusCode !== HttpStatusCode.ok;
        if (isErrorResponseValid) {
            return Observable.throw(error.error.statusMessage);
        }
        return Observable.throw(this.resourceService.get('msg_execute_getrights_failure'));
      });
    return response$;
  }
}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/lookup/wave-control-popups/pick-management-popup/pick-management-popup.component.ts